// app/javascript/folder_modals.js
// Handles opening and closing of folder creation and folder management modals across Doccu

(function () {
  function openNewFolderModal (e) {
    if (e) {
      if (typeof e.preventDefault === 'function') e.preventDefault()
      if (typeof e.stopPropagation === 'function') e.stopPropagation()
    }
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur()
    }
    const modal = document.getElementById('new_folder_modal')
    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) {
        modal.showModal()
      }
      setTimeout(() => {
        const input = document.getElementById('new_folder_name_input')
        if (input) input.focus()
      }, 50)
    }
  }

  function closeNewFolderModal (e) {
    if (e) {
      if (typeof e.preventDefault === 'function') e.preventDefault()
      if (typeof e.stopPropagation === 'function') e.stopPropagation()
    }
    const modal = document.getElementById('new_folder_modal')
    if (modal && typeof modal.close === 'function') {
      if (modal.open) {
        modal.close()
      }
    }
  }

  window.openNewFolderModal = openNewFolderModal
  window.closeNewFolderModal = closeNewFolderModal

  // Delegated click listener (CSP & Turbo resilient)
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-action="open-new-folder-modal"]')
    if (openBtn) {
      openNewFolderModal(e)
      return
    }

    const closeBtn = e.target.closest('[data-action="close-new-folder-modal"]')
    if (closeBtn) {
      closeNewFolderModal(e)
    }
  })
})()
